import getStore from './store';
import { OWAConnectedAccount } from './schema/OWAConnectedAccount';
import { getUserPrimarySmtpAddress } from 'owa-client-ids';
import { assertNever } from 'owa-assert';

export function getOWAConnectedAccounts(): OWAConnectedAccount[] {
    return [...getStore().accountsMap.values()];
}

export function getPrimaryAndOWAConnectedAccounts(): OWAConnectedAccount[] {
    return [{ primarySmtpAddress: getUserPrimarySmtpAddress() } as OWAConnectedAccount].concat(
        getOWAConnectedAccounts()
    );
}

export function getOWAConnectedAccount(primarySmtpAddress: string): OWAConnectedAccount {
    return getStore().accountsMap.get(primarySmtpAddress);
}

export function getOWAConnectedAccountStatus(primarySmtpAddress: string): boolean {
    const connectedAccount = getStore().accountsMap.get(primarySmtpAddress);
    if (connectedAccount) {
        return connectedAccount.isAccountValid;
    } else {
        return true;
    }
}

export function getOWAConnectedAccountTokeString(account: OWAConnectedAccount): string {
    if (account.accountProviderType == 'Outlook') {
        return `MSAuth1.0 usertoken="${account.token}", type="MSACT"`;
    } else if (account.accountProviderType == 'Google') {
        return `Bearer ${account.token}`;
    } else {
        return assertNever(account.accountProviderType);
    }
}

export function isOutlookConsumerAccount(primarySmtpAddress: string): boolean {
    const connectedAccount = getStore().accountsMap.get(primarySmtpAddress);
    return connectedAccount && connectedAccount.accountProviderType == 'Outlook';
}
